(() => {
  const COMPONENT_NAME = 'vl-pdp-feature-drawer';
  const VARIANT_ATTRIBUTE = 'data-vl-pdp-feature-drawer-variant';
  const PREVIEW_QUERY_PARAMETER = 'vl_pdp_feature_drawer_variant';
  const MOBILE_MEDIA_QUERY = '(max-width: 767px)';
  const VALID_VARIANTS = new Set(['a', 'b']);

  if (customElements.get(COMPONENT_NAME)) return;

  class VLPdpFeatureDrawer extends HTMLElement {
    static get observedAttributes() {
      return [VARIANT_ATTRIBUTE];
    }

    constructor() {
      super();
      this.isInitialized = false;
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleKlaviyoForm = this.handleKlaviyoForm.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) return;

      this.trigger = document.querySelector(
        `[data-vl-pdp-feature-drawer-trigger][data-vl-pdp-feature-drawer-section-id="${CSS.escape(this.dataset.vlPdpFeatureDrawerSectionId || '')}"]`,
      );

      if (!this.trigger) return;

      document.addEventListener('click', this.handleDocumentClick);
      window.addEventListener('klaviyoForms', this.handleKlaviyoForm);
      this.applyPreviewVariant();
      this.applyVariant();
      this.isInitialized = true;
    }

    disconnectedCallback() {
      if (!this.isInitialized) return;

      document.removeEventListener('click', this.handleDocumentClick);
      window.removeEventListener('klaviyoForms', this.handleKlaviyoForm);
      this.isInitialized = false;
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name !== VARIANT_ATTRIBUTE || oldValue === newValue || !this.isConnected) return;
      this.applyVariant();
    }

    get normalizedVariant() {
      const value = (this.getAttribute(VARIANT_ATTRIBUTE) || '').trim().toLowerCase();
      return VALID_VARIANTS.has(value) ? value : '';
    }

    applyPreviewVariant() {
      if (this.normalizedVariant) return;

      const previewVariant = new URLSearchParams(window.location.search)
        .get(PREVIEW_QUERY_PARAMETER)
        ?.trim()
        .toLowerCase();

      if (VALID_VARIANTS.has(previewVariant)) this.setAttribute(VARIANT_ATTRIBUTE, previewVariant);
    }

    applyVariant() {
      if (!this.trigger) return;

      const variant = this.normalizedVariant;
      const controlId = this.dataset.vlPdpFeatureDrawerControlId;
      const experimentId = this.dataset.vlPdpFeatureDrawerExperimentId;
      const nextDrawerId = variant ? experimentId : controlId;
      const keyFeature = document.querySelector(
        `[data-vl-pdp-key-feature][data-vl-pdp-key-feature-section-id="${CSS.escape(this.dataset.vlPdpFeatureDrawerSectionId || '')}"]`,
      );

      if (!nextDrawerId) return;

      this.dataset.vlPdpFeatureDrawerActiveVariant = variant || 'control';
      this.trigger.dataset.sidebarId = nextDrawerId;
      this.trigger.setAttribute('aria-controls', nextDrawerId);
      if (keyFeature) keyFeature.dataset.vlPdpKeyFeatureVariant = variant || 'control';
    }

    track(eventName) {
      // Queue events until the site's gtag loader is ready.
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
      };

      window.gtag('event', eventName, {
        experiment_variant: this.dataset.vlPdpFeatureDrawerActiveVariant || 'control',
        device: window.matchMedia(MOBILE_MEDIA_QUERY).matches ? 'mobile' : 'desktop',
        page_title: document.title,
      });
    }

    handleDocumentClick(event) {
      if (event.target.closest('[data-vl-pdp-feature-drawer-trigger]') === this.trigger) {
        this.track('pdp_spec_cta_click');
        return;
      }

      const guideCard = event.target.closest('[data-vl-pdp-feature-drawer-guidebook]');
      if (guideCard && guideCard.dataset.vlPdpFeatureDrawerInstance === this.dataset.vlPdpFeatureDrawerInstance) {
        this.track('pdp_guidebook_cta_click');
        this.openGuidebook(event);
        return;
      }

    }

    handleKlaviyoForm(event) {
      if (event.detail?.type !== 'submit') return;

      const formId = event.detail.formId;
      const isGuidebookForm = formId === this.dataset.vlPdpFeatureDrawerKlaviyoDesktopId
        || formId === this.dataset.vlPdpFeatureDrawerKlaviyoMobileId;

      if (isGuidebookForm) this.track('pdp_guidebook_submit');
    }

    openGuidebook(event) {
      event.preventDefault();

      const formId = window.matchMedia(MOBILE_MEDIA_QUERY).matches
        ? this.dataset.vlPdpFeatureDrawerKlaviyoMobileId
        : this.dataset.vlPdpFeatureDrawerKlaviyoDesktopId;

      if (!formId) return;

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }
  }

  customElements.define(COMPONENT_NAME, VLPdpFeatureDrawer);
})();
